// Bugfix 24 (#1394): het filterformulier van het To-Do Overzicht Trainers.
// Een keuze verstuurt het formulier meteen; bij zoeken pas na een korte pauze
// in het typen. Het filteren zelf gebeurt op de server (TodoOverzicht).
import { Controller } from "stimulus"

export default class extends Controller {
  disconnect() {
    window.clearTimeout(this.wachten)
  }

  verstuur() {
    window.clearTimeout(this.wachten)
    this.element.requestSubmit()
  }

  zoekLater() {
    window.clearTimeout(this.wachten)
    this.wachten = window.setTimeout(() => this.element.requestSubmit(), 350)
  }

  sorteer(event) {
    const keuze = event.currentTarget.value
    this.element.querySelector("input[name='sorteer']").value = keuze
    this.element.querySelector("input[name='richting']").value = keuze === "trainer" ? "asc" : "desc"
    this.verstuur()
  }
}
